module.exports = __webpack_public_path__ + "img/captain-falcon-min.9b5ffc31.png";